export default __webpack_public_path__ + "static/media/pictogramBeaconEFTPOS64.3afa57c6.svg";